import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
import "@/assets/styl/vant-reset.styl";

Vue.config.productionTip = false

Vue.prototype.$axios = axios;


import 'babel-polyfill'
// 可伸缩布局( 适配方案 )
import 'lib-flexible'
// 1 边框像素处理
import './assets/styl/border.css'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)
Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js